import { useState, useMemo, useRef } from "react";
import { useTranslate } from "@refinedev/core";

import { usePaginatedTable, useQueryParams } from "@shared/hooks";
import { ModalRef } from "@shared/components";
import { Level } from "@modules/levels/types";

export function useLevelList() {
  const [selectedRows, setSelectedRows] = useState<number[]>([]);

  const createLevelModalRef = useRef<ModalRef>(null);
  const editLevelModalRef = useRef<ModalRef>(null);

  const translate = useTranslate();
  const { getQueryParams } = useQueryParams();

  const { rows, loading, refetch, ...tableProps } = usePaginatedTable<Level>({
    resource: "v1/level_admin",
    filters: getQueryParams(),
  });

  const dataToExport = useMemo(() => {
    return selectedRows.length > 0
      ? rows.filter((row) => selectedRows.includes(row.id))
      : rows;
  }, [selectedRows, rows]);

  return {
    rows,
    loading,
    tableProps,
    selectedRows,
    dataToExport,
    createLevelModalRef,
    editLevelModalRef,
    refetch,
    setSelectedRows,
    translate,
  };
}
